<template>
    <div style="margin-top: 30px;">
          <div style="margin: 20px;color:#f69346;font-size:18px"> 欢迎来到 Master Data Management Portal 后台管理系统!</div>
          <el-card class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
            <p>通知</p>
            <el-table
              :data="msg_list"
              highlight-current-row
              v-loading="listLoading"
              style="width: 100%"
            >
              <el-table-column type="index" width="80"></el-table-column>
              <el-table-column
                prop="title"
                label="通知标题"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <!-- <el-table-column
                prop="outletnumber__c"
                label="发送人"
                width··
              ></el-table-column> -->
              <el-table-column
                prop="createtime"
                label="发送时间"
                width='180'
              ></el-table-column>
              <el-table-column  width='100' label="操作">
                <template scope="scope">
                  <el-link type="primary" @click="handleOpen(scope.row)"> 查看</el-link>   
                </template>
              </el-table-column>
            </el-table>
        </el-card>
          <!-- <div style="margin: 20px;color:red;font-size:14px"><span style="color:red">通知：</span>网站将于03月02日 07:00pm进行系统维护, 期间网站可能无法访问，敬请谅解，谢谢.</div> -->
<!-- <el-card class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
    <p>权限说明域</p>
</el-card> -->
<el-card v-if="account_card || store_card" class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
    <el-row>
        <el-col v-if="account_card" :span="8">
           <p>客户</p>
           <el-link href="CustomerManagement/Non_layer1_list" type="primary">{{form_lists.account_count}}个</el-link>
        </el-col>
        <el-col v-if="store_card" :span="8">
           <p>门店</p>
            <el-link href="StoreManage/store_list" type="primary">{{form_lists.store_count}}个</el-link>
        </el-col>
    </el-row>
</el-card>
<el-card v-if="account_approve_card || store_approve_card || account_approve_card_layer2" class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
    <el-row>
        <el-col v-if="account_approve_card" :span="8">
           <p>待审批客户</p>
            <el-link href="CustomerManagement/Approval_not" type="primary">{{form_lists.account_Approval_count}}个</el-link>
        </el-col>
        <el-col v-if="account_approve_card_layer2" :span="8">
           <p>待审批客户</p>
            <el-link href="CustomerManagement/Non_layer1_list" type="primary">{{form_lists.account_Approval_count}}个</el-link>
        </el-col>
        <el-col v-if="store_approve_card" :span="8">
           <p>待审批门店</p>
            <el-link href="StoreManage/store_approve_not" type="primary">{{form_lists.store_Approval_count}}个</el-link>
        </el-col>
         <!-- <el-col :span="8"> -->
           <!-- <p>待审批ecp</p> -->
           <!-- <el-link href="EcpManage/EcpManage_list_approve" type="primary">{{store_card_num}}0个</el-link> -->
        <!-- </el-col> -->
    </el-row>
</el-card>
<el-card  v-if='ecp_approve_card' class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
    <el-row>
         <el-col :span="8">
           <p>待审批ecp</p>
           <el-link href="EcpManage/EcpManage_list_approve" type="primary">{{form_lists.ecp_Approval_count}}个</el-link>
        </el-col>
    </el-row>
</el-card>
<el-card  v-if='member_Overrun_Approval_count || store_Qouta_Approval_count ' class="welcome-card" style="margin-top:20px;width: 98%;font-size:18px;margin-bottom:20px">
    <el-row>
         <el-col v-if="member_Overrun_Approval_count" :span="8">
           <p>待审批客户</p>
            <el-link href="CustomerManagement/Non_layer1_list" type="primary">{{form_lists.member_Overrun_Approval_count}}个</el-link>
        </el-col>
        <el-col v-if="store_Qouta_Approval_count" :span="8">
           <p>待审批门店</p>
            <el-link href="StoreManage/store_approve_not" type="primary">{{form_lists.store_Qouta_Approval_count}}个</el-link>
        </el-col>
    </el-row>
</el-card>


    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="width">
      <h3>{{dialogVisible_title}}</h3>
      <div   v-if="dialogVisible_files"><el-button @click="btn_up_YX" type="primary">下载附件</el-button></div>
      <div><i class="fa fa-paperclip" v-if="dialogVisible_filename" aria-hidden="true">{{dialogVisible_filename}}</i></div>
      <div v-html="dialogVisible_html"></div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">关 闭</el-button> -->
      </div>
    </el-dialog>
    </div>

</template>

<script>
    import applicationUserManager from "../Auth/applicationusermanager";
    import {getServerInfo,getAccessLogs,getIds4UsersGrow,account_info_GetIndex,MessageInfo_GetList} from '../api/api';
  
  export default {
        name: "Welcome",
         data() {
            return {
              dialogVisible_html:'',
              dialogVisible_files:'',
              dialogVisible_filename:'',
              dialogVisible_title:'',
              dialogVisible:false,
              msg_list:[],
                form_lists:[],
                account_card:false,
                store_card:false,
                store_approve_card:false,
                account_approve_card:false,
                ecp_approve_card:false,
                member_Overrun_Approval_count:false,
                store_Qouta_Approval_count:false,
                account_approve_card_layer2:false,
                listLoading: false,

                logs: [],
                serverInfo:{},
                extend: {
                    series: {
                    label: {
                        normal: {
                        show: true
                        }
                    }
                    }
                },
                lineChartData7Day: {
                    columns: [],
                    rows: []
                },
                lineChartSettings7Day: {
                    metrics: ["count"],
                    dimension: ["date"]
                },
                lineChartMarkPoint: {
                    data: [
                    {
                        name: "最大值",
                        type: "max"
                    },
                    {
                        name: "最小值",
                        type: "min"
                    }
                    ]
                },
            }
        },
        methods:{
            handleOpen(e){
            this.dialogVisible_html = e.text
            this.dialogVisible_files = e.files
            this.dialogVisible_title = e.title
            this.dialogVisible_filename = e.filename
            this.dialogVisible=true
             },
             btn_up_YX() {
              window.open("/" + this.dialogVisible_files);
            },
        },
        beforeCreate(){
            let that = this
            let iframe_uri = that.$route.query.iframe_uri
            let iframe_ts = that.$route.query.iframe_ts
            if(that.$route.path=="/" && iframe_uri && iframe_ts){
                if(localStorage.getItem("iframe_ts") != iframe_ts){
                    localStorage.setItem("iframe_ts",iframe_ts)
                    that.$router.push(that.$route.query.iframe_uri);
                }
            }
        },
        mounted() {
         
             MessageInfo_GetList({
              pageSize:10
             }).then((res) => {
                this.msg_list = res.data.response.data
            });

            let roleNames = JSON.parse(localStorage.getItem("roleNames"));
                // account_card
                // store_card
                // store_approve_card
                // account_approve_card
                // ecp_approve_card
            if ( roleNames.find((e) => {return e == "Sales Operation";})) {
                   this.store_card=true
                   this.store_approve_card=true
                   this.account_approve_card_layer2= true
                }
            if ( roleNames.find((e) => {return e == "Sales Analytics";})) {
                   this.store_card=true
                   this.account_approve_card_layer2= true
            }
            if ( roleNames.find((e) => {return e == "AM" || e == "KAM"|| e == "RKAM"})) {
                   this.account_card =  true
                   this.store_card =  true
                   this.ecp_approve_card =  true
            }
            if ( roleNames.find((e) => {return e == "NKAM" || e == "ASM" || e == 'RSM'})) {
                //    this.account_card =  true
                   this.store_card =  true
                //    this.ecp_approve_card =  true
                   this.store_approve_card =  true
                   this.account_approve_card =  true
            }
            if ( roleNames.find((e) => {return e == "TMKT"})) {
                   this.store_card =  true
                   this.store_approve_card =  true
            }
            if ( roleNames.find((e) => {return e == "QA"})) {
                   this.store_card =  true
                   this.store_approve_card =  true
            }
            if ( roleNames.find((e) => {return e == "SD"})) {
                   this.account_approve_card =  true
            }
            if ( roleNames.find((e) => {return e == "SD"})) {
                   this.account_approve_card =  true
            }
            var curTime = new Date()
            if(window.localStorage.TokenExpire){
                var expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
                if(curTime>=expiretime){
                    if (global.IS_IDS4) {
                        applicationUserManager.login();
                    } else {
                        this.$router.push('/jump_link');
                    }
                }
            }else {
                if (global.IS_IDS4) {
                    applicationUserManager.login();
                } else {
                    this.$router.push('/jump_link');
                }
            }

            
            account_info_GetIndex({}).then((res) => {
                console.log(res)
                this.form_lists = res.data.response
            });
            // getIds4UsersGrow({}).then(res => {
            //     this.lineChartData7Day = res.data.response;
            // });

            getServerInfo({}).then((res) => {
                this.serverInfo = res.data.response;
            });

            getAccessLogs({}).then((res) => {
                this.logs = res.data.response;
                this.listLoading = false;
                //NProgress.done();
            });

        },
    }
</script>

<style scoped>
.note .text {
    font-size: 14px;
  }

 .note .item {
    margin-bottom: 18px;
  }
</style>
